import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'highlight' | 'dark';
}
export function Card({
  children,
  className = '',
  variant = 'default',
  ...props
}: CardProps) {
  const baseStyles = 'rounded-3xl overflow-hidden transition-all duration-300';
  const variants = {
    default: 'bg-white border border-rose-100 shadow-sm hover:shadow-md',
    highlight: 'bg-white border-2 border-brand-primary shadow-xl shadow-rose-200/50 ring-4 ring-rose-50',
    dark: 'bg-brand-dark border border-rose-900/30 shadow-lg text-white'
  };
  return <div className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-281">
      {children}
    </div>;
}